module.exports = __webpack_public_path__ + "img/expert.b7c16001.svg";